import React, { createContext, useContext, useEffect, useState, useRef } from "react";

const ModalContext = createContext();
export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [closedCount, setClosedCount] = useState(0); // how many times user closed
  const timerRef = useRef(null);

  // Show modal first time after 5s
  useEffect(() => {
    if (!timerRef.current && closedCount === 0) {
      timerRef.current = setTimeout(() => {
        setShowModal(true);
      }, 5000);
    }
  }, [closedCount]);

  // If closed once → reopen after 55s
  useEffect(() => {
    let timer;
    if (closedCount === 1) {
      timer = setTimeout(() => {
        setShowModal(true);
      }, 55000);
    }
    return () => clearTimeout(timer);
  }, [closedCount]);

  const handleClose = () => {
    setShowModal(false);
    setClosedCount((prev) => prev + 1);
  };

  return (
    <ModalContext.Provider value={{ showModal, setShowModal, handleClose }}>
      {children}
    </ModalContext.Provider>
  );
};
